import { __assign, __rest } from "tslib";
// DS5.2
import React from 'react';
import c from 'classnames';
import Tabs from '../..';
import s from './UnderlinedTabs.scss';
export var UnderlinedTabs = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b, uniformTabWidth = _a.uniformTabWidth, items = _a.items, props = __rest(_a, ["size", "uniformTabWidth", "items"]);
    return (React.createElement(Tabs, __assign({}, props, { items: items.map(function (item) {
            if (item.hasNotification) {
                var modifiedItem = __assign(__assign({}, item), { labelExtras: React.createElement("div", { className: s['notification-dot'] }) });
                return modifiedItem;
            }
            return item;
        }), viewClassNames: {
            root: c(s['root'], s[size], uniformTabWidth && s['uniform-tabs']),
            tab: s['tab'],
            label: s['label'],
            prefix: s['prefix'],
            'active-tab': s['active-tab'],
        } })));
};
UnderlinedTabs.displayName = 'UnderlinedTabs';
export default UnderlinedTabs;
//# sourceMappingURL=UnderlinedTabs.js.map